export default "__VITE_ASSET__DwJopjyd__"